import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Web3Provider } from "./context/Web3Context";
import { NotificationProvider } from "./hooks/useNotification";
import Navbar from "./components/Layout/Navbar";
import BottomNav from "./components/Layout/BottomNav";
import GridBackground from "./components/Layout/GridBackground";
import Particles from "./components/Layout/Particles";
import AnnouncementBar from "./components/Layout/AnnouncementBar";
import AnnouncementPopup from "./components/Layout/AnnouncementPopup";
import Toast from "./components/Notification/Toast";
import { useAnnouncement } from "./hooks/useAnnouncement";
import Welcome from "./pages/Welcome";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Packages from "./pages/Packages";
import Matrix from "./pages/Matrix";
import Club from "./pages/Club";
import Admin from "./pages/Admin";

function AppShell() {
  const ann = useAnnouncement();
  const hasAnn = !!(ann && (ann.text || ann.image));
  return (
    <>
      <GridBackground />
      <Particles />
      <div className={`app-shell${hasAnn ? " has-ann" : ""}`}>
        <Navbar />
        <AnnouncementBar />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/home" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/matrix" element={<Matrix />} />
            <Route path="/club" element={<Club />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <BottomNav />
        <Toast />
        <AnnouncementPopup />
      </div>
    </>
  );
}

function App() {
  return (
    <NotificationProvider>
      <Web3Provider>
        <AppShell />
      </Web3Provider>
    </NotificationProvider>
  );
}

export default App;
